<div class="feedback-creator"
  [formGroup]="form"
  [ngClass]="mode"
  [class.mobile-collapsed]="isMobile() && (isMobileCollapsed$ | async) && mode === 'add'">

  @if (mode === 'add') {
    <button
      type="button"
      class="mobile-toggle-bar"
      (click)="toggleMobileCollapse()"
			[attr.aria-label]="((isMobileCollapsed$ | async)
				? 'feedback-session-feedback-creator_expand-comment-creator'
				: 'feedback-session-feedback-creator_collapse-comment-creator') | translate"
      [attr.aria-expanded]="(isMobileCollapsed$ | async) === false">
      <i class="ficon-app-chevron-down" [class.flipped]="isMobileCollapsed$ | async"></i>
    </button>
  }

  <section [ngClass]="{'feedback-creator-error': characterMaxExceeded}"
    class="feedback-creator-body">
    @if (showCloseBtn()) {
      <button
        type="button"
        class="close-btn"
        attr.aria-label="{{'common_close'| translate}}"
        (click)="closeEditor()">
        <i class="ficon-app-x"></i>
      </button>
    }
    <div class="comment-creator-header"
      [hidden]="!(expandedView && mode === 'add') && tagsList.length === 0">
      @if (!activity.isConversationBoard()) {
        @if (expandedView && time !== null && mode === 'add') {
          <span
            class="timestamp">
            <span>{{time | formatTime}}</span>
            <button class="remove-timestamp"
              (click)="removeTimestamp()"
              attr.aria-label="{{'feedback-creator_timestamp-remove' | translate}}">
              <i class="ficon-app-x"></i>
            </button>
          </span>
        }
        @if (expandedView && time === null && mode === 'add') {
          <button
            type="button"
            class="add-timestamp"
            translate="feedback-creator_timestamp"
            attr.aria-label="{{'feedback-creator_timestamp-add' | translate}}"
            (click)="addTimestamp()">
          </button>
        }
      }
      <div class="tags-container"
        [ngClass]="mode"
        [class.no-timestamp]="!expandedView || mode !== 'add'">
        @for (tag of tagsList; track tag) {
          <marker
            [marker]="tag"
            [showButton]="true"
            [withName]="isSelfDemo"
            [disabled]="isTagSelected(tag.tag_id)"
            (select)="selectTag(tag)">
          </marker>
        }
      </div>
      <div class="overflow-tags-button-container" style="visibility: hidden;">
        <button
          type="button"
          class="btn-none tags-menu-btn icon-btn"
          attr.aria-label="{{'feedback-creator_open-tag-overflow' | translate}}"
          aria-haspopup="menu"
          [matMenuTriggerFor]="tagsMenu">
          <i class="ficon-app-chevron-down flipped"></i>
        </button>
        <mat-menu class="tag-menu" #tagsMenu="matMenu" yPosition="above">
          @for (tag of tagsList; track tag) {
            <button mat-menu-item class="tag-menu-item"
              (click)="selectTag(tag)"
              [disabled]="isTagSelected(tag.tag_id)">
              <marker
                [marker]="tag"
                [disabled]="isTagSelected(tag.tag_id)">
              </marker>
              <span translate="{{tag.tag_name}}"></span>
            </button>
          }
        </mat-menu>
      </div>
    </div>
    @if (tagResources.length) {
      <div class="resource-tags">
        @for (tag of tagResources; track tag) {
          <marker
            [marker]="tag.item"
            [withName]="true"
            [showRemove]="true"
            (remove)="removeTag(tag)">
          </marker>
        }
      </div>
    }
    <div class="rich-text-editor-container">
      @if (expandedView) {
        <ngx-rich-text-editor
          formControlName="commentText"
          [label]="'feedback-creator_add-comment_label' | translate"
          [autoSize]="true"
          [containerClass]="'feedback-display-content'"
          [autoFocus]="true"
          [toolbarBelow]="mediaResources.length ? 'extra' :'withBorder'"
          [toolbarOptions]="'bold underline bullist'"
          [toolbarGroups]="true"
          [hasRightButton]="mayHaveComposerButton()"
          (enterEvent)="submitComment($event)"
          (maxCharactersEvent)="updateCharacterCount($event)"
          (onEditorFocusOut)="onEditorFocusOut($event)"
        ></ngx-rich-text-editor>
      }
      @if (showComposerButton$() | async) {
        <button
          class="comment-composer-btn"
          [matTooltip]="'feedback-creator_improve-comment' | translate"
          [matTooltipPosition]="'above'"
          #aiCommentAssistantMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="aiCommentAssistantMenu"
          >
          <i class="ficon-sparkles" aria-hidden="true"></i>
        </button>
      }
      <mat-menu #aiCommentAssistantMenu="matMenu" yPosition="above" class="ai-comment-assistant-menu-panel">
        <ng-template matMenuContent>
          <div (click)="$event.stopPropagation()">
            <ai-comment-assistant-menu
              [commentText]="form.controls.commentText.value"
              [tagResources]="tagResources"
              [sessionId]="session.session_id"
              [time]="time"
              (onClose)="closeAICommentAssistantMenu()"
              (onApplyImprovedComment)="applyImprovedComment($event)"
            ></ai-comment-assistant-menu>
          </div>
        </ng-template>
      </mat-menu>
    </div>

    @if (mediaResources.length) {
      <div class="resource-thumbnails">
        @for (resource of mediaResources; track resource) {
          <ngx-media-thumbnail
            (removeEvent)="removeAttachment(resource)"
            [media]="resource.item"
          ></ngx-media-thumbnail>
        }
      </div>
    }
    <div class="comment-creator-footer"
			[ngClass]="{
				'no-top-border': (expandedView || tagsList.length > 0),
				'expanded': expandedView,
				'compact': (mode === 'reply' || mode === 'edit')
			}">
      <span class="pull-left text-comment-container">
        @if (!expandedView) {
          <button
            data-tour="add-comment-btn"
            data-cy="commentCreator-expand"
            type="button"
            (click)="expandCommentCreator(true)"
            translate="feedback-creator_add-comment"
            class="add-comment-btn">
          </button>
        }
      </span>
      @if (!typesAreUpdating) {
        <span class="pull-right feedback-actions-container">
          <button
            class="btn-none emoji-btn recent-feedback-type-btn icon-btn"
            data-cy="emoji-btn"
            [attr.aria-label]="'feedback-creator_open-emoji-picker' | translate"
            [matMenuTriggerFor]="emojiMenu"
            #emojiMenuTrigger="matMenuTrigger"
            (click)="focusSearchField()"
            [matTooltip]="'feedback-creator_open-emoji-picker' | translate">
            <i class="ficon-smile-o"></i>
          </button>
          <mat-menu class="emoji-menu" #emojiMenu="matMenu" yPosition="above">
            <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <emoji-mart
                cdkTrapFocus
                [darkMode]="false"
                [color]="'#00A39A'"
                [totalFrequentLines]="1"
                [isNative]="true"
                title=""
                emoji=""
                [autoFocus]="true"
                [useButton]="true"
                [emojisToShowFilter]="emojiFilter"
                (emojiClick)="addEmoji($event)"
                (keydown)="handleKeyDownEmojiPopup($event)">
              </emoji-mart>
            </div>
          </mat-menu>
          @for (recentFeedbackType of recentFeedbackTypes; track recentFeedbackType) {
            <button
              class="btn-none recent-feedback-type-btn icon-btn"
              [attr.aria-label]="recentFeedbackType.label | translate"
              [matTooltip]="recentFeedbackType.label | translate"
              (click)="selectFeedbackOption(recentFeedbackType.type)">
              <i class="{{recentFeedbackType.icon}}"></i>
            </button>
          }
          <button
            type="button"
            class="feedback-types-btn icon-btn"
            [attr.aria-label]="'feedback-creator_open-feedback-options' | translate"
            [matMenuTriggerFor]="feedbackTypesMenu"
            [matTooltip]="'feedback-creator_open-feedback-options' | translate">
            <i class="ficon-add"></i>
          </button>
          <mat-menu #feedbackTypesMenu="matMenu" yPosition="above">
            @for (feedbackType of feedbackTypes; track feedbackType) {
              <button mat-menu-item
                (click)="selectFeedbackOption(feedbackType.type)">
                <mat-icon class="{{feedbackType.icon}}"></mat-icon>
                <span translate="{{feedbackType.label}}"></span>
              </button>
            }
          </mat-menu>
          @if (saving$ | async) {
            <span class="ficon-spinner ficon-spin"></span>
          }
          @if ((saving$ | async) !== true) {
            <button
              data-cy="commentCreator-send"
              type="submit"
              (click)="submitComment()"
              [disabled]="!isUnsaved()"
              [attr.tabindex]="isUnsaved() ? 0 : -1"
              [ngClass]="{'light-up': isUnsaved()}"
              attr.aria-label="{{'feedback-creator_submit' | translate}}"
              class="btn-none submit-comment-btn">
              <i class="ficon-app-send"></i>
            </button>
          }
        </span>
      }
    </div>
  </section>
  @if (characterMaxExceeded) {
    <mat-error
      id="feedback-creator-error"
      class="character-count-error"
      role="alert"
      >
      {{
      'feedback-creator_add-comment-error_exceeds_character_limit' | translate:{characterLimit, amountExceededBy}
      }}
    </mat-error>
  }
</div>
